import RotateLeftIcon from '@material-ui/icons/RotateLeft';

export const IconReset = RotateLeftIcon;

export { RedactionResetPage as default } from './RedactionResetPage';